import { details } from './details';
export const stats = {
  namespaced: true,
  modules: {
    details
  }
};
